@use "/src/presentation/themes/spectroflow-theme/dist/css/spectroflow-theme";

$toolbar_height: 3rem;

html,
body {
  font-family: "Roboto-Regular", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh; //if height is not explicitly set for any of the parent elements, % units are broken for height in all child elements. So lets set it in the html body(highest element in the hierarchy);
  max-height: 100vh;
  min-width: 100vh;
  width: 100vw; //same with width
  max-width: 100vw;
  min-width: 100vh;
  flex: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#root {
  height: 100vh; //if height is not explicitly set for any of the parent elements, % units are broken for height in all child elements. So lets set it in the html body(highest element in the hierarchy);
  max-height: 100vh;
  min-width: 100vh;
  width: 100vw; //same with width
  max-width: 100vw;
  min-width: 100vh;
}

.page-toolbar {
  height: $toolbar_height;
}

.page-content-with-toolbar {
  height: calc(100% - $toolbar_height);
  width: 100%;
  max-width: 100%;
}

.fill-all {
  height: 100%;
  width: 100%;
}

.sub-legend {
  @extend .k-form-legend !optional; // Inherits styles from k-form-legend
  font-size: 0.85em; // Smaller font size for sublegend
  color: #575757; // Custom color for sublegend
  margin-top: 20px; // Additional top margin for spacing
  padding-left: 10px; // Indentation for subcategory
}

/* Force all detail grid backgrounds to look like selected */
.k-grid .k-detail-row {
  background-color: #e9e9e9 !important;
}

/* Optional: also adjust nested grid cells so they inherit */
.k-grid .k-detail-row .k-grid {
  background-color: inherit;
}

.k-grid .k-detail-row .k-grid td {
  background-color: inherit;
}

.k-grid tr.k-master-row:hover td:first-child,
.k-grid tr.k-master-row.k-state-selected td:first-child {
  border-left: 3px solid #007bff;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.k-grid tr.k-master-row:hover td:last-child,
.k-grid tr.k-master-row.k-state-selected td:last-child {
  border-right: 3px solid #007bff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.k-grid .k-grid-header tr {
  font-weight: bold; // Emphasize header text
  font-size: 1.1em; // Slightly bigger header text
}

/* ================================
   Job List Theme Enhancements
   ================================ */

/* Toolbar styling */
.page-toolbar {
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  padding: 0 1rem;
  min-height: 48px;
}

/* Grid header stays visible while scrolling */
.k-grid .k-grid-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ffffff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}

/* Parent job rows (master rows) */
.k-grid tr.k-master-row {
  background-color: #fafafa;
  border-bottom: 2px solid #ddd;
  font-weight: 500;
}

/* Child rows (detail rows) */
.k-grid .k-detail-row {
  background-color: #f5f5f5 !important;
  border-left: 3px solid #ccc;
  padding-left: 1rem;
}

/* Status badges */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  min-width: 90px;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-running {
  background-color: #e6f7ff;
  color: #0056b3;
}

.status-completed {
  background-color: #d4edda;
  color: #155724;
}

.status-failed {
  background-color: #f8d7da;
  color: #721c24;
}

/* Mini progress bar for job steps */
.job-progress-bar {
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  height: 8px;
  width: 100px;
  margin: 0.25rem 0;
}

.job-progress-bar-fill {
  background: #007bff;
  height: 100%;
  transition: width 0.3s ease;
}

/* Optional: compact grid rows for dense data */
.k-grid td {
  padding: 0.5rem 0.75rem;
}

/* Increase row height for better spacing (helps progress bar fit nicely) */
.k-grid .k-grid-content tr {
  height: 3.6rem; // default ~2.6rem, slightly taller
}

/* Optional: adjust detail rows to match */
.k-grid .k-detail-row {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

/* Prevent any temporary border when clicking or tabbing */
.k-grid td:focus,
.k-grid td:active {
  outline: none !important;
  box-shadow: none !important;
  // border-color: transparent !important;
}

/* Prevent text selection during multi-select operations */
.k-grid {
  user-select: auto !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Allow text selection within specific content areas if needed */
.k-grid .k-grid-content {
  user-select: auto !important;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

/* Prevent text selection during row selection */
.k-grid tr.k-master-row,
.k-grid .k-detail-row {
  user-select: auto !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.k-form-legend {
  text-transform: none !important;
  /* The theme default is a muted grey that reads as disabled next to the field
     labels. Section titles are the main way to scan a long form, so they get the
     maximum contrast. The theme sets no colour on the legend, so this plain
     class selector is enough. */
  color: #000000;
}

/* Re-asserted after the rule above: `.sub-legend` @extends `.k-form-legend`, so it
   is folded into that selector list and would otherwise inherit the darker colour
   that is meant to distinguish top-level sections from subsections. */
.sub-legend {
  color: #575757;
}